import AbstractNotifier from '@/utils/Services/Agent/Notifiers/AbstractNotifier';
import MailNotifyPolicy from "@/policies/Proposal/Product/ProductPolicy/MailNotifyPolicy";

export default class MailNotifier extends AbstractNotifier {
    get title() {
        return 'Mail notify';
    }

    get notificationTitle() {
        return 'Notificatie via mail';
    }

    isSelectable() {
        return true;
    }

    proposalProductPolicy() {
        return MailNotifyPolicy;
    }

    canCancelProduct() {
        return true;
    }

    cancelProductConfirmMessage(agentProduct) {
        return super.cancelProductConfirmMessage(agentProduct) +
            "<br /><br /><strong>Let op:</strong> de agent zal geen e-mail ontvangen.";
    }

    hasCancellationOptionalSending() {
        return true;
    }
}
